import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "La laurea online vale come quella in presenza?",
    a: "Sì, in tutto e per tutto. Pegaso, Mercatorum e San Raffaele sono atenei telematici riconosciuti dal MIUR. Il titolo conseguito ha lo stesso valore legale di una laurea tradizionale ed è valido per concorsi pubblici, abilitazioni professionali, accesso a magistrali e dottorati.",
  },
  {
    q: "Quanto costa una laurea online?",
    a: "Dipende dall'ateneo e dal corso, ma grazie alla convenzione del Polo Profili puoi risparmiare fino al 50% sulla retta. Il pagamento è dilazionato in comode rate mensili. Tasse universitarie, esami e materiale didattico sono inclusi.",
  },
  {
    q: "Quanto tempo posso prendere per laurearmi?",
    a: "L'università telematica non ha vincoli di frequenza: studi a tempi tuoi. Una triennale può essere completata in 3 anni (durata standard) o anche in più tempo se hai impegni lavorativi o familiari. Hai libertà totale di gestione del piano studi.",
  },
  {
    q: "Posso lavorare mentre studio?",
    a: "Assolutamente sì. Le lezioni sono registrate e disponibili 24/7 su qualsiasi dispositivo. La maggior parte dei nostri studenti concilia lavoro, famiglia e studio. Il tutor del Polo ti aiuta a pianificare un percorso sostenibile.",
  },
  {
    q: "Come faccio a scegliere l'università giusta per me?",
    a: "Prenota un orientamento gratuito con il nostro tutor: in 30 minuti analizziamo i tuoi obiettivi, esperienze e tempi disponibili per consigliarti l'ateneo e il corso più adatti. Senza impegno e senza costi.",
  },
  {
    q: "Posso convalidare esami sostenuti in altri atenei?",
    a: "Sì. Se hai esami sostenuti in università italiane o straniere, possiamo richiedere il riconoscimento. Il tutor del Polo gestisce tutta la pratica di trasferimento e abbreviazione del piano di studi.",
  },
  {
    q: "Le certificazioni EIPASS sono incluse?",
    a: "Sì, le certificazioni EIPASS Informatico ed EIPASS Linguistico (B2/C1/C2) sono incluse nei pacchetti del Polo Profili. Sono riconosciute dal MIUR e valide per concorsi e graduatorie scolastiche.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section className="py-20 lg:py-28 bg-brand-surface" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <div className="eyebrow text-brand-emerald mb-3">Domande frequenti</div>
            <h2 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl text-brand-navy leading-[1.05]">
              Le risposte<br />ai tuoi dubbi.
            </h2>
            <p className="mt-5 text-brand-muted text-lg leading-relaxed">
              Tutto quello che vuoi sapere sulla laurea online, prima di iscriverti. Se non trovi la tua domanda, parla con un tutor.
            </p>
            <a
              href="https://wa.me/393465726648?text=Ciao,%20ho%20una%20domanda%20sui%20corsi"
              target="_blank"
              rel="noreferrer"
              className="btn-secondary mt-7 inline-flex"
              data-testid="faq-whatsapp-cta"
            >
              Hai un'altra domanda? Scrivici
            </a>
          </div>
        </div>

        <div className="lg:col-span-7 space-y-3" data-testid="faq-list">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={`rounded-2xl border bg-white transition-all duration-300 ${
                  isOpen ? "border-brand-emerald shadow-md" : "border-brand-line"
                }`}
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-5 p-5 lg:p-6 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="font-heading font-bold text-base lg:text-lg text-brand-navy">{f.q}</span>
                  <ChevronDown className={`w-5 h-5 shrink-0 text-brand-emerald transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />
                </button>
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 lg:px-6 pb-6 text-brand-ink leading-relaxed text-[15px]">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
